import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ModalStep } from './steps';
import { CircularProgress, Text, VStack, Spacer } from '@chakra-ui/react';
export function AwaitingWalletCreationStep({ currentStep, percentKeygenDone, }) {
    if (currentStep !== ModalStep.AWAITING_WALLET_CREATION && currentStep !== ModalStep.AWAITING_WALLET_CREATION_AFTER_LOGIN) {
        return null;
    }
    return (_jsxs(VStack, { justifyContent: "center", alignItems: "center", flex: 1, children: [_jsx(Text, { marginTop: '100px', fontSize: "22px", children: "Creating wallet..." }), _jsx(CircularProgress, { top: '8px', size: "60px", thickness: "10px", color: 'brand.content', trackColor: 'brand.contentSecondary', value: percentKeygenDone }), _jsx(Spacer, {})] }));
}
